module.exports = __webpack_public_path__ + "static/media/KaTeX_Math-Italic.7a31741a.woff2";